module.exports = __webpack_public_path__ + "media/images/emblems/Thusis_wappen-396988bc03a1ea1c38f650f869bd7fe2.svg";